import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOneGallery, updateGallery } from '../../../slice/gallerySlice';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Update = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, oneData } = useSelector((state) => state.gallery);

    const [formData, setFormData] = useState({
        title: '',
        location: '',
        status: 1
    });
    const [images, setImages] = useState([]);

    useEffect(() => {
        dispatch(getOneGallery(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (oneData) {
            setFormData({
                title: oneData.title || '',
                location: oneData.location || '',
                status: oneData.status ?? 1
            });
        }
    }, [oneData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setImages(e.target.files);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const data = new FormData();
        Object.entries(formData).forEach(([key, val]) => data.append(key, val));
        if (images.length > 0) {
            for (let i = 0; i < images.length; i++) {
                data.append('images', images[i]);
            }
        }

        dispatch(updateGallery({ id, data }));
        toast.success('Gallery updated successfully!');
        setTimeout(() => navigate('/khajuraho/gallery'), 1500);
    };

    const getImageUrl = (imgJson) => {
        try {
            const imgs = JSON.parse(imgJson);
            const backend = process.env.REACT_APP_BACKEND || 'http://localhost:8001/';
            const base = backend.endsWith('/') ? backend : backend + '/';
            return `${base}uploads/${imgs[0].trim()}`;
        } catch (e) {
            return '';
        }
    };

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Update Gallery Item</h4>
            </div>
            <form onSubmit={handleSubmit} className="bg-white p-4 mx-4 mt-5 rounded shadow">
                <div className="row">
                    <div className="col-sm-12 mt-2">
                        <label htmlFor="title" className="adminlables">Title</label>
                        <input type="text" id="title" name="title" value={formData.title} className="form-control" onChange={handleChange} required />
                    </div>
                    <div className="col-sm-6 mt-4">
                        <label htmlFor="location" className="adminlables">Location</label>
                        <input type="text" id="location" name="location" value={formData.location} className="form-control" onChange={handleChange} />
                    </div>
                    <div className="col-sm-6 mt-4">
                        <label htmlFor="status" className="adminlables">Status</label>
                        <select id="status" name="status" value={formData.status} className="form-control" onChange={handleChange}>
                            <option value={1}>Active</option>
                            <option value={0}>Inactive</option>
                        </select>
                    </div>
                    <div className="col-sm-12 mt-4">
                        <label htmlFor="images" className="adminlables">Update Images (Optional)</label>
                        <input type="file" id="images" className="form-control filebg" onChange={handleFileChange} multiple />
                        {oneData?.images && (
                            <div className="mt-3">
                                <p className="small text-muted mb-1">Current Image Preview:</p>
                                <img src={getImageUrl(oneData.images)} alt="" width="150" className="rounded shadow-sm" />
                            </div>
                        )}
                    </div>
                </div>
                <div className="mt-5 text-right">
                    <button type="submit" className="btn btn-lg addbtn" disabled={loading}>
                        {loading ? 'Updating...' : 'Update Gallery'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Update;
